import { Notify, Dialog } from 'vant'
import commonData from '@/commondata.js'
import ImageCompressor from 'image-compressor.js'
import store from '@/store'
import { GetSelfUrl, GetServiceUrlBase } from '@/utils/request'
import router from '@/router'
import axios from 'axios'

// 判断是否是在AliPay小程序中
export function checkIsInAlipay(always) {
  if (always === true) {
    return true
  }
  var userAgentBody = navigator.userAgent
  var isIn = userAgentBody.indexOf('AlipayClient') > 0
  return isIn
}

// 分组
export const groupBy = (list, fn) => {
  const groups = {}
  list.forEach(function(o) {
    const group = JSON.stringify(fn(o))
    groups[group] = groups[group] || []
    groups[group].push(o)
  })
  // return Object.keys(groups).map(function (group) {
  //     return groups[group];
  // });
  return groups
}

export function checkServiceState(callback) {
  if (!callback) {
    return
  }
  axios.get(GetServiceUrlBase() + '/state.txt')
    .then((response) => {
      if (response.data === '1' || response.data === 1) {
        callback()
      } else {
        axios.get(GetServiceUrlBase() + '/maintaining.txt')
          .then((response) => {
            callback(response.data)
          })
          .catch((error) => {
            console.log(error)
            callback('与服务器断开连接,可能是网络不佳或服务器正在维护,请稍后再试或联系客服!')
          })
      }
    })
    .catch((error) => {
      console.log(error)
      // callback('与服务器断开连接,可能是网络不佳或服务器正在维护,请稍后再试或联系客服!')
      callback()
    })
}

export function jumpUrl(url) {
  if (url && url.startsWith('/')) {
    this.$router.push(url)
  } else {
    window.location.href = url
  }
}
export function cutString(data, len) {
  if (!data || len <= 0 || data.length <= len) {
    return data
  }
  return data.substring(0, len)
}
export function isEmptyStr(obj) {
  if (typeof obj === 'undefined' || obj == null || obj === '') {
    return true
  } else {
    return false
  }
}
export function showValue(data) {
  if (data && data.length > 0) {
    return data
  }
  return '-'
}
export function getUserBase(callback, isNoJump) {
  if (commonData.userBase === undefined) {
    store.dispatch('user/getUserBase').then(data => {
      var system = getUrlKey('system')
      if (commonData.userBase && commonData.userBase.myStoreKey && commonData.userBase.myStoreKey !== system && !isNoJump) {
        Dialog.confirm({
          title: '是否回到自己的店铺',
          message: '您访问了别人的店铺，是否现在回到自己的店铺?',
          confirmButtonText: '回自己店',
          cancelButtonText: '留下来'
        }).then(() => {
          var nowUrl = router.history.current.fullPath
          console.log('url', nowUrl)
          console.log('system', system)
          var newUrl = nowUrl.replace('system=' + system, 'system=' + data.myStoreKey)
          window.location.href = GetSelfUrl().substring(0, GetSelfUrl() - 1) + newUrl
        }).catch(() => {
          if (callback) {
            callback(commonData.userBase)
          }
        })
        return
      }
      if (callback) {
        callback(commonData.userBase)
      }
      return
    })
  } else {
    if (callback) {
      callback(commonData.userBase)
    }
  }
}
export function UrlBase64(data) {
  if (!data) {
    return data
  }
  return data.replace('+', '*').replace('/', '-').replace('=', '.')
}
export function ShowFloat(value, num) {
  if (!value) {
    return value
  }
  if (num === 0) {
    return parseInt(value + 0.5)
  }
  if (!num) {
    num = 1
  }
  return value.toFixed(num)
}
export function getScoreText(score) {
  if (score >= 5) {
    return '非常好'
  } else if (score >= 4) {
    return '好'
  } else if (score >= 3) {
    return '一般'
  } else if (score >= 2) {
    return '较差'
  } else {
    return '非常差'
  }
}
export function ShowMoney(money) {
  if (money >= 0) {
    var fee = parseInt((money * 100 + 0.5))
    return (fee / 100).toFixed(2)
  } else {
    var fee1 = parseInt((money * 100 - 0.5))
    return (fee1 / 100).toFixed(2)
  }
}
export function ShowMoneySpan(money, isFirst) {
  if (money >= 0) {
    var fee = parseInt((money * 100 + 0.5))
    var result = (fee / 100).toFixed(2).toString().split('.')
    return result[isFirst ? 0 : 1]
  } else {
    var fee1 = parseInt((money * 100 - 0.5))
    var result1 = (fee1 / 100).toFixed(2).toString().split('.')
    return result1[isFirst ? 0 : 1]
  }
}
export function compressorImageList(list, maxWidth, maxHeight, quality, callback) {
  var num = 0
  var newList = []
  list.map((value, index, array) => {
    compressorImage(value, maxWidth, maxHeight, quality, function(data, name) {
      num++
      newList.push({ file: data, name: name })
      if (num >= list.length) {
        if (callback) {
          callback(newList)
        }
      }
    })
  })
}
export function compressorImage(file, maxWidth, maxHeight, quality, callback) {
  var u = navigator.userAgent
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  // eslint-disable-next-line no-undef
  new ImageCompressor(file, {
    checkOrientation: isIOS,
    quality: quality,
    maxHeight: maxHeight,
    maxWidth: maxWidth,
    success(result) {
      console.log('压缩图片成功', result)
      if (callback) {
        callback(result, result.name)
      }
    },
    error(e) {
      console.log('压缩图片失败', e)
      if (callback) {
        callback(file)
      }
    }
  })
}

export function MyNotify(type, body, duration) {
  // ### 正常 蓝#7ecef4  提示 灰#bfbfbf  异常 红#dd423c
  switch (type) {
    case 'error':
      Notify({
        message: body,
        duration: duration | 3000,
        background: '#dd423c'
      })
      break
    case 'info' :
      Notify({
        message: body,
        duration: duration | 2000,
        background: '#e37d19'
      })
      break
    default:
      Notify({
        message: body,
        duration: duration | 2000,
        background: '#7ecef4'
      })
  }
}
/* 检测用户名，是否加空格，联系5个字符每空格即为不正确的*/
export function checkUserLastName(name, callback) {
  if (!name || name.length < 2) {
    MyNotify('error', '请输入英文(拼音)名')
    return
  }
  if (name.length <= 5) {
    if (callback) {
      callback()
    }
    return
  }
  var words = name.split(' ')
  for (let i = 0; i < words.length; i++) {
    const item = words[i]
    if (item.length > 5) {
      Dialog.confirm({
        title: '英文(拼音)名不含空格',
        message: '您输入的英文(拼音)名“' + name + '”每个中文字之间未添加空格(正确样例:“san feng”)，这样将有可能导致无法搜索出来您的资质，是否要继续?',
        confirmButtonText: '下一步',
        cancelButtonText: '修改'
      }).then(() => {
        if (callback) {
          callback()
        }
      }).catch(() => {
        return
      })
      return
    }
    if (i === words.length - 1) {
      callback()
    }
  }
}
/* eslint-disable */
export function getUrlKey(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}
export function getRestTime(time){
  if(time<60)
  {
    return time+'分钟'
  }else if(time<60*24)
  {
    return Math.floor(time/24)+'小时'
  }else
  {
    return Math.floor(time/1440)+'天'
  }
}
export function getTimeState () {
    let timeNow = new Date();
    let hours = timeNow.getHours();
    let text = ``;
    if (hours >= 0 && hours <= 10) {
        text = `早上好`;
    } else if (hours > 10 && hours <= 14) {
        text = `中午好`;
    } else if (hours > 14 && hours <= 18) {
        text = `下午好`;
    } else if (hours > 18 && hours <= 24) {
        text = `晚上好`;
    }       
    return text 
}
export function afterDateNow(date, utcTime = false) {
  if (!(date instanceof Date)) {
    date = new Date(date)
  }
  // 自动计算时间时区问题
  if (utcTime) {
    var utcToLoacl = new Date().getTimezoneOffset() * 60 * 1000
    var tm = date.getTime() - utcToLoacl
    date = new Date(tm)
  }
  return date > new Date()
}
export function formatDate(date, fmt, utcTime = false) {
    // 自动转换成时间对象
    if (!(date instanceof Date)) {
      date = new Date(date)
    }
    // 自动计算时间时区问题
     if (utcTime) {
       var utcToLoacl = new Date().getTimezoneOffset() * 60 * 1000
       var tm = date.getTime() - utcToLoacl
       date = new Date(tm)
    }
    // 格式化时间
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    }
    for (const k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        const str = o[k] + ''
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
      }
    }
    return fmt
  }
  
function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}
function PrefixInteger(num, length) {
  return (Array(length).join('0') + num).slice(-length)
}

export function formatTimeOfDate(time) {
  if (time >= 1440) {
    time = 1439
  }
  if (time < 60) {
    return '00:' + PrefixInteger(time, 2)
  } else {
    var h = Math.floor(time / 60)
    return PrefixInteger(h, 2) + ':' + PrefixInteger(time % 60, 2)
  }
}
export function GetColorMainBack(){
  return commonData.storeBase === undefined? '#ff4444':commonData.storeBase.mainBackColor
}
export function GetColorMain(){
  return commonData.storeBase === undefined? '#ff4444':commonData.storeBase.mainColor
}
export function GetColorMainLine(){
  return commonData.storeBase === undefined? '#ff4444':commonData.storeBase.mainLineColor
}
export function GetColorMainGradual(){
  return commonData.storeBase === undefined? '#ff4444':commonData.storeBase.mainGradualColor
}
export function GetColorSecondary(){
  return commonData.storeBase === undefined? '#323232':commonData.storeBase.secondaryColor
}
export function GetSysTitle(){
  return commonData.storeBase === undefined? '':commonData.storeBase.title
}
export function GetDiveTitle(){
  return commonData.storeBase === undefined? '':commonData.storeBase.diveTitle
}
export function GetDiveMainBack(){
  return commonData.storeBase === undefined? 'diveMainBack':commonData.storeBase.diveMainBack
}
export function GetProfitsharingStore(){
  return commonData.storeBase === undefined? true:commonData.storeBase.isStoreBind
}
export function GetProfitsharingAgent(){
  return commonData.storeBase === undefined? true:commonData.storeBase.isAgentBind
}
export function GetHideDiveBossCommission(){
  return commonData.storeBase === undefined? false:commonData.storeBase.isHideDiveBossCommission 
}
export function GetEnbaleDiveComment(){
  return commonData.storeBase === undefined? false:commonData.storeBase.isEnbaleDiveComment 
}
export function GetIsEnableInsurance(){
  return commonData.storeBase === undefined? false:commonData.storeBase.isEnableInsurance 
}

export function GetEnumList(enumClassName) {
  if(commonData.enumList == undefined)
  {
    return [];
  }
  var list = commonData.enumList.find(item => item.key === enumClassName).lists
  var result = []
  for (const item of list) {
    result.push({
      text: item.value,// 'enum.' + enumClassName + '.' + item.key,
      value: item.key
    })
  }
  return result
}

export function GetEnumText(enumClassName,enumName)
{
  var list = GetEnumList(enumClassName);
  if(list.length===0)
  {
    return enumName
  }
  var item = list.find(item=>item.value === enumName);
  if(item === undefined)
  {
    return enumName;
  }
  return item.text
}

export function GetAreaNameByCode(data,code)
{
  console.log(code,data);

  return "测试";
}
export function randomNum(minNum,maxNum){ 
  switch(arguments.length){ 
      case 1: 
          return parseInt(Math.random()*minNum+1,10); 
      case 2: 
          return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10); 
          default: 
              return 0; 
  } 
} 
///百度地图  每个尺寸级别对应 一厘米实际距离 单位米
export function baiduLevelMetre(level){
  switch(level)
  {
    case 1:return 10000*1000;
    case 2:return 5000*1000;
    case 3:return 2000*1000;
    case 4:return 1000*1000;
    case 5:return 500*1000;
    case 6:return 200*1000;
    case 7:return 100*1000;
    case 8:return 50*1000;
    case 9:return 25*1000;
    case 10:return 20*1000;
    case 11:return 10*1000;
    case 12:return 5*1000;
    case 13:return 2*1000;
    case 14:return 1000;
    case 15:return 500;
    case 16:return 200;
    case 17:return 100;
    case 18:return 50;
    case 19:return 20;
    default: return 20;
  }
}